exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-item.b-nav-dropdown a:active, .nav-item.b-nav-dropdown a:focus {\n  border: none;\n  outline: none;\n}\n@media (max-width: 992px) {\n.nav-item.b-nav-dropdown a span {\n    color: #aa4121;\n}\n}\n.nav-item.b-nav-dropdown .nav-link {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.nav-item.b-nav-dropdown .nav-link:hover, .nav-item.b-nav-dropdown .nav-link:focus {\n  color: #fff;\n}\n.nav-item.b-nav-dropdown .dropdown-toggle::after {\n  display: none;\n}\n#logo-md {\n  height: 140px;\n}\n@media (max-width: 992px) {\n#logo-md {\n    height: 200px;\n}\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};